<div class="option-container">
    <p-dropdown [options]="years" (onChange)="changeYear($event.value)"></p-dropdown>
</div>
<p-table #dataTable [value]="invoices">
    <ng-template pTemplate="header">
        <tr>
            <th>
                Booking ID
            </th>
            <th>
                School
            </th>
            <th>
                Active
            </th>
            <th>
                Gabriel
            </th>
            <th>
                Name
            </th>
            <th>
                Inv. Number
            </th>
            <th>
                File
            </th>
            <th>
                Departure
            </th>
            <th>
                Date
            </th>
            <th>
                Comment
            </th>
            <th>
                Amt
            </th>
            <th>
                Currency
            </th>
        </tr>
        <tr>
            <th>
                <input #idInput pInputText (input)="dataTable.filter($any($event.target)?.value, 'bookingId', 'contains')" [value]="$any(dataTable).filters['bookingId']?.value">
            </th>
            <th>
                <input #schoolNameInput pInputText (input)="dataTable.filter($any($event.target)?.value, 'schoolName', 'contains')" [value]="$any(dataTable).filters['schoolName']?.value">
            </th>
            <th>
                <p-checkbox binary="true" [(ngModel)]="isActive" (onChange)="dataTable.filter(isActive, 'isActive', 'equals')"></p-checkbox>
            </th>
            <th>
                <p-checkbox binary="true" [(ngModel)]="withElb" (onChange)="dataTable.filter(withElb, 'isElb', 'equals')"></p-checkbox>
            </th>
            <th>
                <input #studentNameInput pInputText (input)="dataTable.filter($any($event.target)?.value, 'studentName', 'contains')" [value]="$any(dataTable).filters['studentName']?.value">
            </th>
            <th>
                <input #invoiceNumberInput pInputText (input)="dataTable.filter($any($event.target)?.value, 'invoiceNumber', 'contains')" [value]="$any(dataTable).filters['invoiceNumber']?.value">
            </th>
            <th></th>
            <th>
                <p-calendar appendTo="body" (onSelect)="onStartDateSelect($event)" (onClearClick)="dataTable.filter('', 'startDate', 'equals')" [inputStyle]="{'width':'100%'}" 
                 [showButtonBar]="true" styleClass="ui-column-filter" placeholder="Start Date" [readonlyInput]="true" dateFormat="dd/mm/yy"></p-calendar>
            </th>
            <th>
                <p-calendar appendTo="body" (onSelect)="onInvoiceDateSelect($event)" 
                (onClearClick)="dataTable.filter('', 'invoiceDate', 'equals')" [showButtonBar]="true" [readonlyInput]="true" dateFormat="dd/mm/yy" [inputStyle]="{'width':'100%'}"></p-calendar>
            </th>
            <th>
                <input #commentInput pInputText (input)="dataTable.filter($any($event.target)?.value, 'comment', 'contains')" [value]="$any(dataTable).filters['comment']?.value">
            </th>
            <th>
                <input #amountInput pInputText (input)="dataTable.filter($any($event.target)?.value, 'amount', 'contains')" [value]="$any(dataTable).filters['amount']?.value">
            </th>
            <th>
                <p-multiSelect [options]="currencyIsoCodes" [(ngModel)]="selectedCurrencyIsoCodes" 
                (onChange)="dataTable.filter($event.value, 'currency.isoCode', 'in')"></p-multiSelect>
            </th>
        </tr>
    </ng-template>
    <ng-template pTemplate="body" let-invoice>
        <tr>
            <td routerLink="/management/edit-booking/{{invoice.lvcId}}">
                {{invoice.bookingId}}
            </td>
            <td>
                {{invoice.schoolName}}
            </td>
            <td>
                <p *ngIf="invoice.isActive">X</p>
            </td>
            <td>
                <p *ngIf="invoice.isElb">E</p>
            </td>
            <td>    
                {{invoice.studentName}}
            </td>
            <td>
                {{invoice.invoiceNumber}}
            </td>
            <td>
                <p-button *ngIf="invoice.fileId" icon="pi pi-download" (onClick)="downloadInvoice(invoice)"></p-button>
            </td>
            <td>
                {{invoice.startDate | date:'dd/MM/yyyy'}}
            </td>
            <td>
                {{invoice.invoiceDate | date:'dd/MM/yyyy'}}
            </td>
            <td>
                {{invoice.comment}}
            </td>
            <td>
                {{invoice.amount}}
            </td>
            <td>
                {{invoice.currency.isoCode}}
            </td>
        </tr>
    </ng-template>
</p-table>